import Footer from '../component/Footer';
import chplay from '../component/image/chplay.png';

export default function Download() {
    const steps = [
        { step: 1, title: 'Mở CH Play / App Store', desc: 'Mở cửa hàng ứng dụng trên điện thoại của bạn', icon: '📱' },
        { step: 2, title: 'Tìm kiếm "VuaLingo"', desc: 'Gõ tên ứng dụng vào thanh tìm kiếm', icon: '🔍' },
        { step: 3, title: 'Tải và cài đặt', desc: 'Nhấn nút "Cài đặt" và đợi tải xong', icon: '⬇️' },
        { step: 4, title: 'Đăng nhập & Học', desc: 'Mở app, đăng nhập bằng Google và bắt đầu học', icon: '🎓' },
    ];

    const features = [
        { title: 'Học Offline', desc: 'Tải bài học về máy, học mọi lúc mọi nơi không cần internet', icon: '📶' },
        { title: 'Luyện nghe mọi lúc', desc: 'Nghe bài học khi đi bộ, tập gym, hay trước khi ngủ', icon: '🎧' },
        { title: 'Theo dõi tiến độ', desc: 'Xem streak, thời gian học, và điểm số trên điện thoại', icon: '📊' },
        { title: 'Thông báo nhắc học', desc: 'App sẽ nhắc bạn học đúng giờ mỗi ngày', icon: '🔔' },
        { title: 'Giao diện đẹp', desc: 'Thiết kế hiện đại, dễ sử dụng trên mọi kích thước màn hình', icon: '✨' },
        { title: 'Miễn phí cơ bản', desc: 'Sử dụng nhiều tính năng miễn phí, nâng cấp VIP để mở khóa tất cả', icon: '💎' },
    ];

    return (
        <>
            <div className="min-h-screen bg-gradient-to-b from-[#eef9ff] to-white">
                {/* Hero */}
                <div className="bg-gradient-to-r from-[#667eea] to-[#764ba2] text-white py-20">
                    <div className="max-w-screen-xl mx-auto px-6">
                        <div className="flex flex-col md:flex-row items-center gap-12">
                            <div className="flex-1 text-center md:text-left">
                                <h1 className="text-4xl md:text-5xl font-extrabold mb-4">Tải App VuaLingo</h1>
                                <p className="text-lg text-purple-100 mb-8">Học tiếng Anh mọi lúc, mọi nơi trên điện thoại của bạn. Miễn phí!</p>
                                <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                                    <a href="#" className="inline-flex items-center gap-3 bg-black text-white px-6 py-3 rounded-xl hover:bg-gray-800 transition-colors shadow-lg">
                                        <img src={chplay} alt="Google Play" className="w-8 h-8" />
                                        <div className="text-left">
                                            <p className="text-xs text-gray-300">Available on</p>
                                            <p className="text-base font-semibold">Google Play</p>
                                        </div>
                                    </a>
                                    <a href="#" className="inline-flex items-center gap-3 bg-black text-white px-6 py-3 rounded-xl hover:bg-gray-800 transition-colors shadow-lg">
                                        <svg className="w-8 h-8" viewBox="0 0 24 24" fill="white"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
                                        <div className="text-left">
                                            <p className="text-xs text-gray-300">Download on the</p>
                                            <p className="text-base font-semibold">App Store</p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div className="flex-shrink-0">
                                <div className="w-64 h-[500px] bg-white bg-opacity-10 rounded-[40px] border-4 border-white border-opacity-30 p-4 flex items-center justify-center">
                                    <div className="text-center">
                                        <p className="text-6xl mb-4">📱</p>
                                        <p className="text-xl font-bold">VuaLingo</p>
                                        <p className="text-sm text-purple-200 mt-2">Learn English Effortlessly</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="max-w-screen-xl mx-auto px-6 py-12">
                    {/* Steps */}
                    <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Hướng dẫn tải app</h2>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-16">
                        {steps.map((s, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-xl transition-shadow relative">
                                {index < steps.length - 1 && (
                                    <div className="hidden md:block absolute top-1/2 -right-3 text-gray-300 text-2xl">→</div>
                                )}
                                <div className="text-4xl mb-4">{s.icon}</div>
                                <div className="w-8 h-8 mx-auto mb-3 rounded-full bg-blue-500 text-white flex items-center justify-center font-bold text-sm">{s.step}</div>
                                <h3 className="font-bold text-lg mb-2">{s.title}</h3>
                                <p className="text-gray-600 text-sm">{s.desc}</p>
                            </div>
                        ))}
                    </div>

                    {/* Features */}
                    <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center">Tính năng nổi bật</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                        {features.map((f, index) => (
                            <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all hover:-translate-y-1">
                                <div className="text-3xl mb-3">{f.icon}</div>
                                <h3 className="font-bold text-lg mb-2 text-gray-800">{f.title}</h3>
                                <p className="text-gray-600 text-sm">{f.desc}</p>
                            </div>
                        ))}
                    </div>

                    {/* CTA */}
                    <div className="bg-gradient-to-r from-[#667eea] to-[#764ba2] rounded-2xl p-8 md:p-12 text-white text-center">
                        <h2 className="text-3xl font-bold mb-4">Tải ngay, học ngay!</h2>
                        <p className="text-purple-100 mb-6">Hơn 10,000+ học viên đã tin dùng VuaLingo</p>
                        <div className="flex gap-4 justify-center">
                            <a href="#" className="inline-block bg-white text-purple-600 font-bold px-8 py-3 rounded-full hover:bg-purple-50 transition-colors shadow-lg">Tải cho Android</a>
                            <a href="#" className="inline-block bg-white bg-opacity-20 text-white font-bold px-8 py-3 rounded-full hover:bg-opacity-30 transition-colors border border-white border-opacity-30">Tải cho iOS</a>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}
